import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { pageMap, site } from "data/site";
import faqData from "data/faq.json";
import { createSchemaTools } from "../../seo/schema.mjs";

const { buildSchema, getCanonicalPath, pageUrlForPath } = createSchemaTools(site, faqData);
const getPage = (pathname) => pageMap[pathname] || null;

function updateHead(page, pathname) {
  if (!page) return;

  const canonicalUrl = pageUrlForPath(pathname);
  document.title = page.title;

  const setMeta = (selector, attribute, key, value) => {
    let element = document.head.querySelector(selector);
    if (!element) {
      element = document.createElement("meta");
      element.setAttribute(attribute, key);
      document.head.appendChild(element);
    }
    element.setAttribute("content", value);
  };

  setMeta('meta[name="description"]', "name", "description", page.description);
  setMeta('meta[property="og:title"]', "property", "og:title", page.title);
  setMeta('meta[property="og:description"]', "property", "og:description", page.description);
  setMeta('meta[property="og:url"]', "property", "og:url", canonicalUrl);
  setMeta('meta[property="og:type"]', "property", "og:type", "website");
  setMeta('meta[property="og:site_name"]', "property", "og:site_name", site.name);
  setMeta('meta[property="og:image"]', "property", "og:image", `${site.siteUrl}${site.logo}`);
  setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
  setMeta('meta[name="twitter:title"]', "name", "twitter:title", page.title);
  setMeta('meta[name="twitter:description"]', "name", "twitter:description", page.description);
  setMeta('meta[name="twitter:image"]', "name", "twitter:image", `${site.siteUrl}${site.logo}`);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = canonicalUrl;

  const schema = buildSchema(page, pathname);
  let schemaElement = document.head.querySelector('script[data-astro-schema="true"]');
  if (!schemaElement) {
    schemaElement = document.createElement("script");
    schemaElement.type = "application/ld+json";
    schemaElement.dataset.astroSchema = "true";
    document.head.appendChild(schemaElement);
  }
  schemaElement.textContent = JSON.stringify(schema);
}

function SeoSchema() {
  const { pathname } = useLocation();

  useEffect(() => {
    updateHead(getPage(pathname), pathname);
  }, [pathname]);

  return null;
}

export { buildSchema, getCanonicalPath, getPage };
export default SeoSchema;
